export const isLocalAccessToken = (token: string | null | undefined): boolean =>
  Boolean(token?.startsWith('local-access.'));

export const isLocalRefreshToken = (token: string | null | undefined): boolean =>
  Boolean(token?.startsWith('local-refresh.'));

export const isLocalAccount = (account: string): boolean =>
  /^demo(?:-[a-z0-9]{6})?$/.test(account.trim());
